import React from 'react';
import config from '../../../../config';
import Header from '../../../components/Header/Header';
import Toolbar from '../../../components/Toolbar/Toolbar';
import Table from '../../../components/Table/Table';
import NavBar from '../../../components/NavBar/NavBar';
import NumberFilter from '@inovua/reactdatagrid-community/NumberFilter';
import * as Yup from 'yup';
import BoolFilter from '@inovua/reactdatagrid-community/BoolFilter';
import { Switch } from '@mui/material';
import DateFilter from '@inovua/reactdatagrid-community/DateFilter';
import { useTranslation } from 'react-i18next';

const Currency = () => {
  const urls = {
    list: config.CURRENCY,
    create: config.CURRENCY,
    update: config.CURRENCY_WITH_ID,
    delete: config.CURRENCY_WITH_ID
  };
  const resource = 'SYSTEM';
  const { t } = useTranslation();

  const columns = [
    {
      header: t('id'),
      name: 'currencyId',
      type: 'number',
      filterEditor: NumberFilter
    },
    {
      header: () => t('name'),
      name: 'currencyName',
      type: 'string',
      validationSchema: Yup.string().max(255).required('Name is required'),
      isEditable: true,
      required: true,
      defaultFlex: 1
    },
    {
      header: t('code'),
      type: 'string',
      validationSchema: Yup.string().max(3).required('Code is required'),
      isEditable: true,
      required: true,
      name: 'currencyCode'
    },
    {
      header: t('symbol'),
      type: 'string',
      validationSchema: Yup.string().max(3).required('Code is required'),
      isEditable: true,
      name: 'currencySymbol'
    },
    {
      header: t('is.active'),
      name: 'isActive',
      type: 'boolean',
      isEditable: true,
      filterEditor: BoolFilter,
      render: ({ value }) => <Switch disabled checked={value} />
    },
    {
      header: t('date.added'),
      name: 'dateAdded',
      type: 'date',
      filterEditor: DateFilter,
      dateFormat: 'YYYY-MM-DDTHH:mm:ss'
    },
    {
      header: t('date.modified'),
      name: 'dateModified',
      type: 'date',
      filterEditor: DateFilter,
      dateFormat: 'YYYY-MM-DDTHH:mm:ss'
    }
  ];

  return (
    <>
      <Header title={t('currencies')} />
      <Toolbar iamResource={resource} />
      <Table
        iamResource={resource}
        uniqueId={'currencyId'}
        tableId={'currency'}
        columns={columns}
        urls={urls}
      />
      <NavBar />
    </>
  );
};

export default Currency;
